import React from 'react';

import { IBasicStyledProps, Row, SkeletonElement } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import {
  StyledDescriptionSkeleton,
  StyledShadowColumn,
  StyledSmallBar,
  StyledTitleSkeleton,
  StyledCheckBoxCol,
  StyledButtonCol,
  StyledDescriptionCol,
} from './styled';

export const ServiceSkeleton: ReactFCV<IBasicStyledProps> = (rest) => (
  <Row {...rest}>
    <StyledCheckBoxCol xs={1}>
      <SkeletonElement width={1} height={1} />
    </StyledCheckBoxCol>
    <StyledDescriptionCol xs={11} md={9}>
      <StyledTitleSkeleton />
      <StyledDescriptionSkeleton />
    </StyledDescriptionCol>
    <StyledShadowColumn xs={1} />
    <StyledButtonCol xs={11} md={2}>
      <StyledSmallBar />
    </StyledButtonCol>
  </Row>
);
